<template>
  <div class="global-loader-container">
    <div class="loader-content">
      <v-progress-circular
        indeterminate
        color="#f46523"
        size="64"
        width="6"
      ></v-progress-circular>
      <p v-if="message" class="loader-message mt-4">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalLoader",
  props: {
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.global-loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader-content {
  text-align: center;
}

.loader-message {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}
</style>
